const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import { combineElements } from "../../utilities/selectorHelpers";
import QuickWizard from "../../components/QuickWizard/QuickWizard";
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import ProductsTab from './addProductsAmazon.js';
require("./amazonFBAOrderWizard.less");
const targetSelector = "#amazon-fba-order-wizard";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";

// For quick dev prototyping

run(targetSelector, () => {
  const orderFulfillmentCenterSelect = $("#order-fulfillment-center");
  const orderFulfillmentCenterList = orderFulfillmentCenterSelect.data('options');
  const destFacAddressWrapper = $("#dest-fac-address-wrapper");
  const destFacAddress = $("#dest-fac-address");
  const facUsesList = $("#fac-uses-list");
  const shipmentTypeval = ".shipment-type-value";
  let btnKey;

  $(orderFulfillmentCenterList).each(function () {
    const option = $('<option />');
    option.attr('value', this.facId).text(this.facName);
    orderFulfillmentCenterSelect.append(option);
  });

  orderFulfillmentCenterSelect.change(function () {
    const selectedFacility = this.value;
    const facility = orderFulfillmentCenterList.filter(function (obj) {
      return obj.facId == selectedFacility;
    })[0];
    //show address
    destFacAddressWrapper.hide();
    destFacAddress.html('');
    if (facility != null) {
      //$("#"+portletNamespace+"facId").val(facility.facId);
      destFacAddress.append("<div>" + facility.facAddressLine1 + "</div>");
      if (facility.facAddressLine2 != null) {
        destFacAddress.append("<div>" + facility.facAddressLine2 + "</div>");
      }
      destFacAddress.append("<div>" + facility.facCity + ", " + facility.facState + " " + facility.facZipcode + "</div>");
      //show facility/fulfillment uses
      facUsesList.html("");
      facUsesList.append("<div class='q-boldest'>Facility Uses:</div>");
      var facilityUses = false;
      if (facility.attributes != null && facility.attributes.length > 0) {
        $.each(facility.attributes[0], function (key, value) {
          if (key == "IN" && value == true) {
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
            facilityUses = true;
          } else if (key == "FC" && value == true) {
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
            facilityUses = true;
          } else if (key == "DC" && value == true) {
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
            facilityUses = true;
          } else if (key == "RC" && value == true) {
            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
            facilityUses = true;
          }
        });
        if (!facilityUses) {
          facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
        }
      } else {
        facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
      }
      destFacAddressWrapper.show();
    }
  });

  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const form = $(targetSelector);
  // MOVE TO ReviewTab.js
  const validator = form.validate({
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  //Call this submission modal if single shipment, have to export this funtion to window cause, jsp build in response of ajax function.
  function submissionModalForSingleShipment(viewDetailPageURL) {
    submitModalFlow.showSuccessModal();
    setTimeout(function () {
      location.href = viewDetailPageURL;
    }, 1500);
  }

  window.submissionModalForSingleShipment = submissionModalForSingleShipment;

  const noProductsErrorMsg = $(".no-products-added-error-msg");
  noProductsErrorMsg.hide();
  setCancelBtnURL();
  validator.settings.ignore = ":disabled,:hidden";
  let productForm;
  let canGoToProductTab = true;
  let canGoToShipmentTab = false;
  const quickWizard = new QuickWizard(form, {
    tabletWidthNavStep: 844,
    mobileWidthNavStep: 502,
    shouldNavigateToForm: ({ targetForm, direction, currentForm, done }) => {
      if (currentForm.filter(".add-products-tab").length) {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let valid = quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
        if (direction == "FORWARDS") {
          if (targetForm[0].className == "qw-form review") {
            return false;
          }
          else if (valid) {
            productForm = currentForm;
            return productsTabIsValid();
          }
          else {
            return valid;
          }
        }
      } else if (currentForm.filter(".review-tab").length) {
        if (canGoToProductTab) {
          return true;
        } 
        if (direction == "FORWARDS") {
          var selectedShipmentsTypes = 0;
          $('.shipping-type-toggler').each(function () {
            if ($(this).find('.active').length) {
              selectedShipmentsTypes = selectedShipmentsTypes + 1;
            }
            else {
              $(this).closest('.shipmentType-container').find('.shippingType-error').removeClass('hide');
            }
          }
          );
          if (selectedShipmentsTypes < $('.shipping-type-toggler').length) {
            return false;
          }
        }
        else if (direction == "BACKWARDS") {
          showPrevConfirmationModal();
          return false;
        }
        else {

        }
      } else if (currentForm.filter(".review").length) {
        if (canGoToProductTab) {
          return true;
        } else if (direction == "BACKWARDS") {
          if (targetForm[0].className == "qw-form add-products-tab") {
            showPrevConfirmationModal();
            return false;
          }
        }
        else {
          return true;
        }
      } else {
        return false;
      }
    },
    didNavigateToForm: ({ currentForm }) => {
      if (currentForm.filter(".review-tab").length) {
        canGoToProductTab = true;
        canGoToShipmentTab = true;
        submitFailedMsg.hide();
        getShipmentPlan();

      } else if (currentForm.filter(".review").length) {
        canGoToProductTab = false;
        canGoToShipmentTab = true;
        submitFailedMsg.hide();
        getReviewShipmentPlan();
      }
      else {
        removeCurentShipmentPlan();
      }
      return true;
    }
  });
  quickWizard.init();

  const productsTab = new ProductsTab(quickWizard);
  productsTab.init();
  //productsTab.loadProductsOnLoad();


  // END: Real Code
  const showSubmitOrderModalBtn = $('.submit-order-btn');
  const addProductsPanelBtn = $('.add-products-btn');
  const goBackToAddProductsBtn = $('#go-back-to-add-products');
  const closePreviousModalBtn = $('#close-previous-modal-btn');

  const addProductsBtn = $(".add-products-from-list-link");
  const submitOrderBtn = $("#submit-order-over-modal");

  const prevConfirmationModal = $('#previousButtonModal');
  const addProductsModal = $('#listOfProductsModal');
  const submitOrderModal = $('#submitOrderModal');
  const submitModalText = $("#submit-modal-text");
  const submitModalProcessingSection = $("#submit-modal-processing-section");
  const submitModalButtons = $("#submit-modal-buttons");

  const submitFailedMsg = $("#submit-failure-msg");

  // START: IMPORTANT: REAL CODE
  const modalOpts = { backdrop: 'static', show: false };
  prevConfirmationModal.modal(modalOpts);
  addProductsModal.modal(modalOpts);
  submitOrderModal.modal(modalOpts);
  //orderResultsModal.modal(modalOpts);
  // END: IMPORTANT: REAL CODE


  combineElements([addProductsBtn, addProductsPanelBtn]).on("click", function (e) {
    e.preventDefault();
    showAddProductsModal();
  });

  showSubmitOrderModalBtn.on("click", function (e) {
    e.preventDefault();
    showSubmitOrderModal();
    //submitModalProcessingBar.hide();
  });

  combineElements([submitOrderBtn]).on("click", function (e) {
    e.preventDefault();
    //showSubmitOrderModalBtn.hide();
    //submitModalText.hide();
    //submitModalButtons.hide();
    //submitModalProcessingSection.show();

    submitOrderModal.modal("hide");
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: form.data("submit-fba-order-url"),
      type: 'POST',
      data: form.serialize(),
      success: function (resp) {
        if (resp) {
          submitModalFlow.hideAllModals();
          $('#amazon-fba-order-loader').hide();
          $('#order-result-modal-section').html(resp);
          showOrderResultsModal();
        } else {
          //submitOrderModal.modal("hide");
          removeCurentShipmentPlan();
          // submitFailedMsg.show();
        }
      },
      error: function (xhr, status, error) {
        submitOrderModal.modal("hide");
        removeCurentShipmentPlan();
        submitFailedMsg.show();
      }
    });
  });

  function showAddProductsModal() {
    addProductsModal.modal("show");
  }

  function productsTabIsValid() {
    const numberOfProducts = $("#product-tab-create-ord >tbody >tr").length;
    if (numberOfProducts > 0) {
      noProductsErrorMsg.hide();
      return true;
    } else {
      noProductsErrorMsg.show();
      return false;
    }
  }

  function showPrevConfirmationModal() {
    prevConfirmationModal.modal("show");
  }

  goBackToAddProductsBtn.click(function () {
    canGoToProductTab = true;
    quickWizard.gotToForm(productForm);
  });

  function showSubmitOrderModal() {
    submitOrderModal.modal("show");
  }

  function showOrderResultsModal() {
    const orderResultsModal = $('#orderResultsModal');
    orderResultsModal.modal(modalOpts);
    orderResultsModal.modal("show");
  }

  function removeCurentShipmentPlan() {
    $("#shipment-plan-response").hide();
  }
  let response;

  function getShipmentPlan() {
    $("#shipment-plan-response").hide();
    const form = $(targetSelector);
    $('#amazon-fba-order-loader').show();
    $.ajax({
      url: form.data("shipment-plan-url"),
      type: 'POST',
      dataType: 'html',
      data: form.serialize(),
      success: function (resp) {
        if (resp) {
          if ($('#get-shipment-plan-error').length > 0) {
            canGoToProductTab = true;
          }
          else {
            canGoToProductTab = false;
          }
          $('#amazon-fba-order-loader').hide();
          $("#shipment-plan-response").html(resp);
          $("#shipment-plan-response").find(".review-origin-facility").html($("#order-fulfillment-center option:selected").text());
          $("#shipment-plan-response").show();
          generateBtnGroupForShippingType();
          $("#shipment-plan-response").find(".shipping-type-toggler").on('click', onClickOfShippingType);

          setRemoveDiscrepancySkuCall();
          setCancelBtnURL();

        } else {
          $('#amazon-fba-order-loader').hide();
          $("#shipment-plan-response").show();

        }
      },
      error: function (xhr, status, error) {
        canGoToProductTab = true;
        $('#amazon-fba-order-loader').hide();
        $("#shipment-plan-response").show();

      }
    });
  }
  function getReviewShipmentPlan() {
    $("#review-response").hide();
    $('#amazon-fba-review-loader').show();
    $('.submit-order-btn').hide();
    const form = $(targetSelector);
    $.ajax({
      url: form.data("shipment-review-url"),
      type: 'POST',
      dataType: 'html',
      data: form.serialize(),
      success: function (response) {
        if (response) {
          if ($('#get-shipment-plan-error').length > 0) {
            canGoToShipmentTab = true;
          }
          $('#amazon-fba-review-loader').hide();
          $("#review-response").html(response);
          $("#review-response").find(".review-origin-facility").html($("#order-fulfillment-center option:selected").text());
          $("#review-response").show();
          $('.submit-order-btn').show();
          var orderstr = $('[name="orderDetailStr"]').val();
          var ordobj = JSON.parse(orderstr);
          var sType;
          Object.keys(selectedShipmets).forEach(function (si) {
            if (selectedShipmets[si] == "LTL") {
              sType = "Frieght Shipping";
            }
            else {
              sType = "Case Shipping";
            }
            $("#review-response").find('.shipment-type-' + si).text(sType);
            ordobj.order[si - 1].shippingType = selectedShipmets[si];
          }
          );
          $('[name="orderDetailStr"]').val(JSON.stringify(ordobj));
          setRemoveDiscrepancySkuCall();
          setCancelBtnURL();
        } else {
          $('#amazon-fba-review-loader').hide();
          $("#review-response").show();
          
        }
      },
      error: function (xhr, status, error) {
        canGoToProductTab = true;
        $('#amazon-fba-review-loader').hide();
        $("#review-response").show();

      }
    });

  }
  function setRemoveDiscrepancySkuCall() {
    $('#sku-discr-remove-missing-sku-btn').on("click", function (e) {
      e.preventDefault();
      let discrepancySkus = $.parseJSON($("#discrepancy-skus").val());
      $.each(discrepancySkus, function (i, item) {
        let productTabRow = $("#amazon-fba-order-wizard input[value='" + item + "'] ");
        removeProductRelatedRows(productTabRow);
      });

      getShipmentPlan();
    });
  }

  function removeProductRelatedRows(curr) {
    const el = curr;
    const coreProduct = el.closest('tr');
    const childProducts = coreProduct.data("childProducts");
    if (childProducts && childProducts.length) {
      _(childProducts).map(function (childProduct) {
        childProduct.remove();
      });
    }
    coreProduct.remove();
  }

  function setCancelBtnURL() {
    const wizardCancelBtn = $('.qw-cancel');
    wizardCancelBtn.on('click', function () {
      const redirectToLookupPageURL = wizardCancelBtn.data('redirect-to-lookup-page-url');
      location.href = redirectToLookupPageURL;
    });

  }
  let selectedShipmets = {};
  let shippingTypeBtnGroupEl, shippingTypeBtnGroup;
  function generateBtnGroupForShippingType() {
    shippingTypeBtnGroupEl = $('.shipping-type-toggler');
    $('.shipping-type-toggler').each(function () {
      const options =
        {
          distributeWidth: true
        };
      if (selectedShipmets[$(this).find('.q-btn:first').data('shipmentid')]) {
        options.initialActiveKey = selectedShipmets[$(this).find('.q-btn:first').data('shipmentid')];
      }
      shippingTypeBtnGroup = new QuickBtnGroup($(this), options);
      shippingTypeBtnGroup.init();
    }
    )
  }

  function onClickOfShippingType(e) {
    let shipment = $("#shipmentMethod").data('row-shipment');
    e.preventDefault();
    const btn = $(e.target);
    btnKey = btn.data('qb-key');
    selectedShipmets[btn.data('shipmentid')] = btnKey;
  }
});


// WEBPACK FOOTER //
// ./src/pages/order/amazonFBAOrderWizard.js